import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { QuodeLockup, QuodeMark } from '../../theme/QuodeMark';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: '100%',
    height: 64,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 22,
    boxSizing: 'border-box',
    borderBottom: '1px solid var(--q-border)',
    marginBottom: 8,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    // The mark leads the collapsed rail; nudging it keeps the optical centre.
    marginLeft: 0,
  },
  closed: {
    width: sidebarConfig.drawerWidthClosed,
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Quodin home">
        {isOpen ? <QuodeLockup /> : <QuodeMark size={28} alive />}
      </Link>
    </div>
  );
};
